export const SITE_URL = window.location.origin;
export const REDIRECT_URI = `${SITE_URL}/stripe-callback`;

const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;
export const STRIPE_AUTHORIZE_URI = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${REDIRECT_URI}`;
